import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Lightbulb, ArrowRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const OportunidadesCard = () => {
  const [stats, setStats] = useState({ total: 0, liberto: 0, a_terminar: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/oportunidades`, { params: { window_days: 7, only_due: true } });
        const items = res.data?.items || [];
        if (cancelled) return;
        setStats({
          total: items.length,
          liberto: items.filter(i => i.status === 'liberto').length,
          a_terminar: items.filter(i => i.status === 'a_terminar').length,
        });
      } catch (e) {
        // silent
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading || stats.total === 0) return null;

  return (
    <Link to="/oportunidades" className="block group" data-testid="dashboard-oportunidades-card">
      <Card className="border-amber-200 bg-gradient-to-br from-amber-50 to-amber-100/40 hover:shadow-md transition-all">
        <CardContent className="p-5">
          <div className="flex items-center justify-between">
            <div className="flex items-start gap-3">
              <div className="p-2.5 rounded-lg bg-amber-200/60">
                <Lightbulb className="w-5 h-5 text-amber-700" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-amber-700 font-semibold">Oportunidades de Troca</p>
                <p className="text-2xl font-bold text-slate-900 mt-1">
                  {stats.total} <span className="text-sm font-normal text-slate-500">contratos elegíveis</span>
                </p>
                <p className="text-xs text-slate-600 mt-1">
                  <span className="text-emerald-700 font-semibold">{stats.liberto}</span> já libertos · {' '}
                  <span className="text-amber-700 font-semibold">{stats.a_terminar}</span> a terminar em ≤7d
                </p>
              </div>
            </div>
            <ArrowRight className="w-5 h-5 text-amber-600 group-hover:translate-x-1 transition-transform" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default OportunidadesCard;
